// extracted by mini-css-extract-plugin
module.exports = {"container":"Wave_container__3Azkg","waving":"Wave_waving__2yubO"};